<template>
  <div ref="container"><slot></slot></div>
</template>

<script>
  import vis from 'vis';
  import 'vis/dist/vis.css'

  import {createObjectByEval,computeWindowRangeWithBounds} from '@/utils/commonUtils'
    export default {
      name: "vis-graph",
      props:{
        options:{
          type:Object,
          default:()=>{return{}}
        },
        visibleWindow:{
          type:Array,
          require:true
        },
        items:{
          type:Array,
          require:true
        },
        groups:{
          type:Array,
        },
      },
      data:()=>{
        return {
          graph: null,
          itemDataSet:new vis.DataSet([]),
          groupDataSet:new vis.DataSet([])
        }
      },
      mounted() {
        const self=this;

        this.graph = new vis.Graph2d(this.$refs.container, this.itemDataSet, this.groupDataSet,this.options);
        this.graph.setWindow(this.visibleWindow[0],this.visibleWindow[1],{"animation":false})

        this.graph.on("rangechange",e=>{e.byUser?this.$emit("changeVisibleWindow",[+e.start,+e.end,self.graph.body.dom.center.getBoundingClientRect()]):undefined});


      },
      methods:{
        groupsUpdate(groups){
          this.groupDataSet.clear();
          this.groupDataSet.add(groups);
        },
        itemsUpdate(items){
          this.itemDataSet.clear();
          this.itemDataSet.update(items);
        },
        changeWindow(visibleWindow){
          let [newStartTime,newEndTime,bounds] = visibleWindow;

          if (bounds){//если третьим параметром идет bounds
            ([newStartTime,newEndTime] = computeWindowRangeWithBounds(newStartTime,newEndTime,
              bounds,this.graph.body.dom.center.getBoundingClientRect()))
          }
          this.graph.setWindow(newStartTime,newEndTime,{"animation":false})
        }
      },
      watch:{
        visibleWindow:{
          handler(){
            this.changeWindow(this.visibleWindow);
          }
        },
        groups:{
          handler(){
            this.groupsUpdate(this.groups);
          }
        },
        items:{
          handler(){
            this.itemsUpdate(this.items);
          }
        }

      }
    }
</script>

<style scoped>

</style>
